<template>
    <div class="sites-filter-toolbar">
        <CommonFilterTool
            v-model="siteFilters"
            :filter-meta="filterMetas"
            :label-formatter="filterLabelFormatter"
            @addFilter="addFilter"
            :show-add-button="true"
            @applyFilterTemplate="applyFilterTemplate"
            :filter-templates="getFilterTemplates()"
            :selected-filter-template="getSelectedFilterTemplateName()"
            :required-filters="getRequiredBreakdowns()"
        >
        </CommonFilterTool>
    </div>
</template>

<script>
import { mapState } from "vuex";
import CommonFilterTool from "../../Pages/Chatbot/pages/archive/CommonFilterTool.vue";
import moment from "moment";

export default {
    name: "SiteFilterToolbar",
    components: { CommonFilterTool },
    props: {
        value: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            siteFilters: this.value,
            filterMetas: [
                {
                    name: "siteAddress",
                    label: "Site Adresi",
                    materialIcon: "web",
                    controlType: "input",
                    controlProps: {},

                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],

                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "alias",
                    label: "Alias",
                    materialIcon: "alternate_email",
                    controlType: "input",
                    controlProps: {},

                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],

                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "enable",
                    label: "Aktif",
                    materialIcon: "toggle_on",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "suspend",
                    label: "Askıda",
                    materialIcon: "do_not_disturb",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "rootUserName",
                    label: "Root Kullanıcı Adı",
                    materialIcon: "person",
                    controlType: "input",
                    controlProps: {},

                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],

                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "rootUserEmail",
                    label: "Root Kullanıcı E-postası",
                    materialIcon: "email",
                    controlType: "input",
                    controlProps: {},

                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],

                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "phone",
                    label: "Telefon",
                    materialIcon: "phone",
                    controlType: "input",
                    controlProps: {},

                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],

                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "partner.name",
                    label: "Partner Adı",
                    materialIcon: "business",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "contains", "startsWith", "endsWith"],
                    defaultValue: "",
                    valueType: "string",
                    defaultOperator: "equal",
                },
                {
                    name: "paymentMethod",
                    label: "Ödeme Yöntemi",
                    materialIcon: "payment",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Ödeme Yöntemi Seçin",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: "eft", label: "EFT" },
                        { id: "btc", label: "Bitcoin" },
                        { id: "credit-card", label: "Kredi Kartı" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "string",
                    defaultOperator: "equal",
                },
                // Fatura Alanları
                {
                    name: "invoiceInfo.createdCount",
                    label: "Oluşturulan Fatura Sayısı",
                    materialIcon: "receipt",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.totalAmount",
                    label: "Toplam Tutar",
                    materialIcon: "attach_money",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.lastInvoiceDate",
                    label: "Son Fatura Tarihi",
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "date",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.firstInvoiceDate",
                    label: "İlk Fatura Tarihi",
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "date",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.paidCount",
                    label: "Ödenen Fatura Sayısı",
                    materialIcon: "check_circle",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.paidAmount",
                    label: "Ödenen Tutar",
                    materialIcon: "attach_money",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.unpaidCount",
                    label: "Ödenmemiş Fatura Sayısı",
                    materialIcon: "error",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.unpaidAmount",
                    label: "Ödenmemiş Tutar",
                    materialIcon: "money_off",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.lastPaymentDate",
                    label: "Son Ödeme Tarihi",
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "date",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.firstPaymentDate",
                    label: "İlk Ödeme Tarihi",
                    materialIcon: "event",
                    controlType: "date-range-picker",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "date",
                    defaultOperator: "equal",
                },
                {
                    name: "invoiceInfo.tookDaysFromLastPayment",
                    label: "Son Ödemeden Bu Yana Geçen Gün",
                    materialIcon: "hourglass_empty",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                // Plan Alanları
                {
                    name: "planInfo.monthlyPlanCount",
                    label: "Aylık Plan Sayısı",
                    materialIcon: "calendar_today",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.monthly3PlanCount",
                    label: "3 Aylık Plan Sayısı",
                    materialIcon: "calendar_today",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.monthly6PlanCount",
                    label: "6 Aylık Plan Sayısı",
                    materialIcon: "calendar_today",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.yearlyPlanCount",
                    label: "Yıllık Plan Sayısı",
                    materialIcon: "calendar_today",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.foreverPlanCount",
                    label: "Sınırsız Plan Sayısı",
                    materialIcon: "all_inclusive",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.whatsappPlanCount",
                    label: "WhatsApp Plan Sayısı",
                    materialIcon: "chat",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.whatsappBusinessPlanCount",
                    label: "WhatsApp Business Plan Sayısı",
                    materialIcon: "business",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.supsisPlanCount",
                    label: "Supsis Plan Sayısı",
                    materialIcon: "chat_bubble",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.chatbotPlanCount",
                    label: "Chatbot Plan Sayısı",
                    materialIcon: "android",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.instagramPlanCount",
                    label: "Instagram Plan Sayısı",
                    materialIcon: "camera_alt",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.messengerPlanCount",
                    label: "Messenger Plan Sayısı",
                    materialIcon: "message",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.extraPackagePlanCount",
                    label: "Ekstra Paket Plan Sayısı",
                    materialIcon: "add_box",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.customPlanCount",
                    label: "Özel Plan Sayısı",
                    materialIcon: "build",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.featurePlanCount",
                    label: "Özellik Plan Sayısı",
                    materialIcon: "stars",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.whatsappPlanExists",
                    label: "WhatsApp Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.whatsappBusinessPlanExists",
                    label: "WhatsApp Business Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.supsisPlanExists",
                    label: "Supsis Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.chatbotPlanExists",
                    label: "Chatbot Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.instagramPlanExists",
                    label: "Instagram Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.messengerPlanExists",
                    label: "Messenger Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.extraPackagePlanExists",
                    label: "Ekstra Paket Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.customPlanExists",
                    label: "Özel Plan Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                {
                    name: "planInfo.featurePlanExists",
                    label: "Özellik Planı Var Mı?",
                    materialIcon: "check_circle",
                    controlType: "custom-picker",
                    controlProps: {
                        multiple: false,
                        idKey: "id",
                        labelKey: "label",
                        title: "Seçim Yap",
                    },
                    availableOperators: ["equal"],
                    options: [
                        { id: true, label: "Evet" },
                        { id: false, label: "Hayır" },
                        { id: null, label: "Farketmez" },
                    ],
                    defaultValue: null,
                    valueType: "boolean",
                    defaultOperator: "equal",
                },
                // Kullanım Alanları
                {
                    name: "usage.chatCount",
                    label: "Sohbet Sayısı",
                    materialIcon: "chat",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
                {
                    name: "usage.ticketCount",
                    label: "Bilet Sayısı",
                    materialIcon: "confirmation_number",
                    controlType: "input",
                    controlProps: {},
                    availableOperators: ["equal", "less_than", "greater_than"],
                    defaultValue: "",
                    valueType: "number",
                    defaultOperator: "equal",
                },
            ],
            selectedCustomFilterTemplate: "all-sites",
        };
    },
    computed: {
        ...mapState({
            // Vuex durumları buraya eklenecek (eğer gerekiyorsa)
        }),
    },
    methods: {
        addFilter(name, value, autoOpen = true) {
            const meta = this.filterMetas.find((x) => x.name === name);
            const filter = this.siteFilters.find((x) => x.name === name);
            if (filter) {
                this.siteFilters = this.siteFilters.map((x) => {
                    if (x.name === name) {
                        x.filterValue = value || meta.defaultValue;
                        x.operator = meta.defaultOperator;
                    }
                    return x;
                });
            } else {
                this.siteFilters.push({
                    ...meta,
                    filterValue: value || meta.defaultValue,
                    operator: meta.defaultOperator,
                });
            }
            if (autoOpen) {
                setTimeout(() => {
                    const el = document.querySelector(".filter-wrapper-preview[data-filter-name=" + name + "]");
                    if (el) {
                        el.click();
                    }
                }, 100);
            }
        },
        removeFilter(name) {
            this.siteFilters = this.siteFilters.filter((x) => x.name !== name);
        },
        filterLabelFormatter(name, value) {
            const filter = this.filterMetas.find((x) => x.name === name);
            if (filter.controlType === "custom-picker") {
                if (filter.valueType === "boolean" || filter.name === "paymentMethod") {
                    const option = filter.options.find((x) => x.id === value);
                    if (option) {
                        return `${filter.label}: ${option.label}`;
                    } else {
                        return `${filter.label}`;
                    }
                } else {
                    const values = Array.isArray(value) ? value : [value];
                    const selectedValues = values
                        .map((value) => {
                            const option = filter.options.find((x) => x.id == value);
                            return option?.label || value;
                        })
                        .filter(Boolean);
                    return `${filter.label}: ${selectedValues.join(", ")}`;
                }
            } else if (filter.controlType === "input") {
                return `${filter.label}: ${value}`;
            }
            return filter.label;
        },
        getRequiredBreakdowns() {
            const templates = this.getFilterTemplates();
            return templates.find((x) => x.name === this.selectedCustomFilterTemplate)?.requiredFilterNames || [];
        },
        getFilterTemplates() {
            return [
                {
                    name: "all-sites",
                    label: "Tüm Siteler",
                    filter: () => ({}),
                    requiredFilterNames: [],
                },
                {
                    name: "suspended-sites",
                    label: "Askıya Alınmış Siteler",
                    filter: () => ({
                        suspend: { equal: true },
                    }),
                    requiredFilterNames: ["suspend"],
                },
                {
                    name: "paid-at-least-once",
                    label: "En Az 1 Kere Ödeme Yapanlar",
                    filter: () => ({
                        "invoiceInfo.paidCount": { greater_than: 0 },
                    }),
                    requiredFilterNames: ["invoiceInfo.paidCount"],
                },
                {
                    name: "no-payment-last-month",
                    label: "1 Aydan Fazladır Ödeme Yapmayanlar",
                    filter: () => ({
                        "invoiceInfo.lastPaymentDate": {
                            equal: {
                                startDate: moment().subtract(1, "months").startOf("month").format("YYYY-MM-DD"),
                                endDate: null,
                                timeSelect: null,
                            },
                        },
                    }),
                    requiredFilterNames: ["invoiceInfo.lastPaymentDate"],
                },
                {
                    name: "whatsapp-buyers",
                    label: "WhatsApp Satın Alanlar",
                    filter: () => ({
                        "planInfo.whatsappPlanExists": { equal: true },
                    }),
                    requiredFilterNames: ["planInfo.whatsappPlanExists"],
                },
                {
                    name: "chatbot-buyers",
                    label: "Chatbot Satın Alanlar",
                    filter: () => ({
                        "planInfo.chatbotPlanExists": { equal: true },
                    }),
                    requiredFilterNames: ["planInfo.chatbotPlanExists"],
                },
                {
                    name: "yearly-subscribers",
                    label: "Yıllık Satın Alma Yapanlar",
                    filter: () => ({
                        "planInfo.yearlyPlanCount": { greater_than: 0 },
                    }),
                    requiredFilterNames: ["planInfo.yearlyPlanCount"],
                },
            ];
        },
        applyFilterTemplate(name) {
            const template = this.getFilterTemplates().find((x) => x.name === name);
            if (template) {
                const filter = template.filter();
                this.siteFilters = Object.entries(filter).map(([key, value]) => {
                    const meta = this.filterMetas.find((x) => x.name === key);
                    return {
                        ...meta,
                        name: key,
                        filterValue: Object.values(value)[0],
                        operator: Object.keys(value)[0],
                    };
                });
                this.selectedCustomFilterTemplate = name;
            }
        },
        getSelectedFilterTemplateName() {
            return this.getFilterTemplates().find((x) => x.name === this.selectedCustomFilterTemplate)?.label;
        },
    },
    watch: {
        siteFilters: {
            handler() {
                this.$emit("input", this.siteFilters);
            },
            deep: true,
        },
    },
};
</script>

<style scoped lang="scss">
.sites-filter-toolbar {
    display: flex;
    width: 100%;

    .common-filter-tool {
        border-bottom: none;
        overflow: hidden;
        padding: 0px;

        .filters {
            overflow-x: auto;
            overflow-y: hidden;
            scrollbar-width: none;
        }

        .add-button {
            margin: unset !important;
            border-radius: 20px;
            border: 1px dashed var(--color-border-default);
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;
            padding: 1px 5px !important;
            min-width: fit-content;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .clear-preview {
            font-size: 12px;
            font-weight: 600;
            line-height: 24px;

            .material-icons {
                font-size: 15px;
                margin-right: 3px;
            }
        }

        .filter-wrapper-preview {
            border-radius: 20px;
            padding: 1px 5px !important;
            background: white;
            color: black;
            border: 1px solid var(--color-border-default);

            .filter-value-text {
                font-size: 12px;
                font-weight: 600;
                color: #22272d;
                line-height: 24px;
            }

            .material-icons {
                margin-right: 3px;
            }
        }
    }
}
</style>
